<template>
  <div
    class="row"
    style="max-height: 25px"
  >
    <label :for="name">{{ title }}</label>
    <p style="color: red">*</p>
  </div>
</template>

<script>
  import { onMounted } from "vue";

  export default {
    name: "RequiredLabel",
    props: {
      title: String,
      name: String,
    },

    setup(props, { emit }) {
      onMounted(() => {});

      return {};
    },
  };
</script>

<style scoped>
  label {
    font-weight: bold;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.4);
    margin-right: 2px;
  }
</style>
